// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3NxZr","bigColWidth":"Table_bigColWidth__1sxcv","biggerColWidth":"Table_biggerColWidth__1Tog5","row":"Table_row__1Ybzf","col":"Table_col__3NoRr"};